export default __webpack_public_path__ + "6fb7daba04bf1981874225f6ce5a2130.svg";